import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import TremendousButton from './TremendousButton';

interface TremendousWithdrawModalProps {
  show: boolean;
  handleClose: () => void;
}

const TremendousWithdrawModal: React.FC<TremendousWithdrawModalProps> = ({ show, handleClose }) => {
  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Go to tremendous dashboard</Modal.Title>
      </Modal.Header>
      <Modal.Body>Transfer your Tremendous account balance back to your company</Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>
        <TremendousButton />
      </Modal.Footer>
    </Modal>
  );
};

export default TremendousWithdrawModal;
